<template>
  <div class="text-center">
    <p class="h5">Você está prestes a enviar a campanha <strong>{{ campaignTitle }}</strong></p>

    <p class="mt-3" v-if="campaignSegments">
      Essa campanha será direcionada para os seguintes segmentos: <strong>{{campaignSegments}}</strong>
    </p>

    <p class="mt-3">Deseja continuar?</p>

    <!-- Submit -->
    <vx-input-group class="mt-4">
      <vs-button @click="submitData">
        Enviar Campanha
      </vs-button>
    </vx-input-group>
  </div>
</template>

<script>
import newsletterCampaignSegmentHttp from '@/http/requests/newsletterCampaignSegment'

export default {
  name: 'send-campaign-popup',
  props: {
    campaignTitle: {
      type: String,
      default: ''
    },
    campaignId: {
      type: Number|null,
      required: true
    }
  },
  data() {
    return {
      segments: []
    }
  },
  computed: {
    campaignSegments() {
      if (!this.segments.length) {
        return null
      }

      return this.segments.join(", ")
    }
  },
  watch: {
    campaignId: function (val) {
      if (val) {
        newsletterCampaignSegmentHttp.campaignSegments(val)
          .then(res => {
            const segments = res.data.data.campaignSegments.categories;
            this.segments = segments.map(segment => segment.name);
          })
          .catch(err => { console.error(err) })
      }
    }
  },
  methods: {
    submitData() {
      this.$emit("sendCampaign");
    }
  }
}
</script>